import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import api, { apiErrorText } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { fmtDate } from "../lib/format";
import { toast } from "sonner";
import { Percent } from "lucide-react";

const TYPES = [
  { v: "chime", l: "Chime" },
  { v: "cashapp", l: "CashApp" },
  { v: "paypal", l: "PayPal" },
  { v: "venmo", l: "Venmo" },
];

export default function Rates() {
  const [rates, setRates] = useState({});
  const [loading, setLoading] = useState(true);
  const [drafts, setDrafts] = useState({});

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/rates");
      const map = {};
      const d = {};
      r.data.forEach((x) => {
        map[x.wallet_type] = x;
        d[x.wallet_type] = x.rate;
      });
      setRates(map);
      setDrafts(d);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);

  const save = async (type) => {
    try {
      const val = Number(drafts[type]);
      if (!val || val <= 0) {
        toast.error("Rate must be positive");
        return;
      }
      await api.put("/rates", { wallet_type: type, rate: val });
      toast.success(`${type.toUpperCase()} rate updated`);
      load();
    } catch (e) {
      toast.error(apiErrorText(e));
    }
  };

  return (
    <Layout
      title="USD → USDT Rates"
      subtitle="Per-provider manual rate. Applied to new withdrawals."
      testId="rates-page"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
        {TYPES.map(({ v, l }) => {
          const current = rates[v];
          return (
            <div
              key={v}
              className="stat-card p-5"
              data-testid={`rate-card-${v}`}
            >
              <div className="flex items-center justify-between">
                <div className="text-[11px] uppercase tracking-widest text-zinc-500">
                  {l}
                </div>
                <Percent size={13} strokeWidth={1.6} className="text-zinc-400" />
              </div>
              <div className="font-mono text-[30px] font-medium mt-2 tracking-tight">
                {(current?.rate ?? 1).toFixed(4)}
              </div>
              <div className="text-[11px] text-zinc-500 mt-1">
                Updated {current?.updated_at ? fmtDate(current.updated_at) : "—"}
              </div>
              <div className="mt-4 flex gap-2">
                <Input
                  type="number"
                  step="0.0001"
                  value={drafts[v] ?? ""}
                  onChange={(e) =>
                    setDrafts({ ...drafts, [v]: e.target.value })
                  }
                  className="h-9"
                  data-testid={`rate-input-${v}`}
                />
                <Button
                  className="h-9 bg-zinc-900 hover:bg-zinc-800 text-white"
                  onClick={() => save(v)}
                  data-testid={`save-rate-${v}`}
                >
                  Save
                </Button>
              </div>
            </div>
          );
        })}
      </div>

      {loading && (
        <div className="mt-6 text-sm text-zinc-500">Loading…</div>
      )}

      <div className="mt-8 stat-card p-5 text-[13px] text-zinc-600">
        <p>
          <span className="font-medium text-zinc-900">How rates work.</span>{" "}
          When you record a withdrawal, USDT received = USD × rate (provider-specific).
          You can override the rate per-withdrawal if needed.
        </p>
      </div>
    </Layout>
  );
}
